import { BellRing, Link, ShieldOff, Syringe } from "lucide-react";

const ICON_SIZE = 20;

export const menuItems = [
  {
    label: "Healthlink Immunisations",
    value: "healthlink",
    Icon: Link,
  },
  {
    label: "Manual Immunisations",
    value: "manual",
    Icon: Syringe,
  },
  {
    label: "Declined & Not Given",
    value: "declined",
    Icon: ShieldOff,
  },
  {
    label: "Recall",
    value: "recall",
    Icon: BellRing,
  },
];

export const getTabOptions = () =>
  menuItems.map((item) => {
    const Icon = item.Icon;
    return {
      value: item.value,
      label: item.label,
      icon: <Icon size={ICON_SIZE} strokeWidth={2} aria-hidden />,
    };
  });
